/* main.tsx generated by @compiled/babel-plugin v0.32.2 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { entityKeys } from './common/constants';
import GoalForm from './ui/goal-form';
export var createGoalLinkCreatePlugin = function createGoalLinkCreatePlugin(pluginConfig) {
  var formProps = _objectSpread({}, pluginConfig);
  return {
    group: {
      label: 'Teamwork Experiences',
      icon: 'jira-icon',
      key: 'townsquare'
    },
    label: 'goal',
    icon: 'issue-icon',
    key: entityKeys.goal,
    form: /*#__PURE__*/React.createElement(GoalForm, formProps)
  };
};